var api = require("!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../node_modules/mini-css-extract-plugin/dist/loader.js??ref--6-1!../node_modules/css-loader/dist/cjs.js??ref--6-2!../node_modules/postcss-loader/src/index.js??ref--6-3!../node_modules/sass-loader/dist/cjs.js??ref--6-4!./app.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};